// extracted by mini-css-extract-plugin
export default {"navGroup":"FuahIAkm","navGroupTitle":"OwApz5lC"};